// import { useState, useEffect, useMemo } from "react";
import { useState, useEffect } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
// import { Icon } from "@mui/material/";

// Material Dashboard 2 React components
// import MDBox from "theme/components/MDBox";

// Material Dashboard 2 React example components
import Sidenav from "app/Navbars/Sidenav";
import Configurator from "theme/Configurator";

// Material Dashboard 2 React themes
import theme from "theme/assets/theme";
// import themeRTL from "assets/theme/theme-rtl";

// Material Dashboard 2 React Dark Mode themes
import themeDark from "theme/assets/theme-dark";
// import themeDarkRTL from "assets/theme-dark/theme-rtl";

// RTL plugins
// import rtlPlugin from "stylis-plugin-rtl";
// import { CacheProvider } from "@emotion/react";
// import createCache from "@emotion/cache";

// Side Nav Routes
import routes from "app/sideNavRoutes";

// App Routes
import appRoutes from "app/appRoutes";

// Material Dashboard 2 React contexts
import { useMaterialUIController, setMiniSidenav } from "context";

// Images
import brandWhite from "assets/images/logos/logo.png";
import brandDark from "assets/images/logos/logo_dark.png";

import { RequireAuth } from "react-auth-kit";
import AppConfig from "appConfig";
import { AwaitDialogProvider } from "app/components/status_dialog";

export default function App() {
  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    direction,
    layout,
    // openConfigurator,
    sidenavColor,
    transparentSidenav,
    whiteSidenav,
    darkMode,
  } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  // const [rtlCache, setRtlCache] = useState(null);
  const { pathname } = useLocation();

  // Cache for the rtl
  // useMemo(() => {
  //   const cacheRtl = createCache({
  //     key: "rtl",
  //     stylisPlugins: [rtlPlugin],
  //   });

  //   setRtlCache(cacheRtl);
  // }, []);

  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  // Change the openConfigurator state
  // const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  // const handleDarkMode = () => setDarkMode(dispatch, !darkMode);

  // Setting the dir attribute for the body element
  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        if (route.secure === true) {
          return (
            <Route
              exact
              path={route.route}
              element={<RequireAuth loginPath="/sign-in">{route.component}</RequireAuth>}
              key={route.key}
            />
          );
        }
        return (
          <Route
            exact
            path={route.route}
            element={route.component}
            key={route.key}
            name={route.name}
          />
        );
      }

      return null;
    });

  const getAppRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.secure) {
        return (
          <Route
            exact
            path={route.route}
            element={<RequireAuth loginPath="/sign-in">{route.component}</RequireAuth>}
            key={route.key}
          />
        );
      }
      return (
        <Route
          exact
          path={route.route}
          element={route.component}
          key={route.key}
          title={route.name}
        />
      );
    });

  // const configsButton = (
  //   <MDBox
  //     display="flex"
  //     justifyContent="center"
  //     alignItems="center"
  //     width="3.25rem"
  //     height="3.25rem"
  //     bgColor="white"
  //     shadow="sm"
  //     borderRadius="50%"
  //     position="fixed"
  //     right="2rem"
  //     bottom="2rem"
  //     zIndex={99}
  //     color="dark"
  //     sx={{ cursor: "pointer" }}
  //     onClick={handleDarkMode}
  //   >
  //     <Icon fontSize="small" color="inherit">
  //       contrast
  //     </Icon>
  //   </MDBox>
  // );

  return (
    <ThemeProvider theme={darkMode ? themeDark : theme}>
      <CssBaseline />
      {layout === "dashboard" && (
        <>
          <Sidenav
            color={sidenavColor}
            brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
            brandName={AppConfig.app_name}
            routes={routes}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
          />
          <Configurator />
          {/* {configsButton} */}
        </>
      )}
      {layout === "vr" && <Configurator />}
      <AwaitDialogProvider>
        <Routes>
          {getRoutes(routes)}
          {getAppRoutes(appRoutes)}
          <Route path="*" element={<Navigate to="/home" />} />
        </Routes>
      </AwaitDialogProvider>
    </ThemeProvider>
  );
}
